module.exports = __webpack_public_path__ + "img/9.3d7d98f7.jpg";